import { ISurvey } from "../../EnterpriseGPTApi/EnterpriseGPTApiV1Client";

type SetSurvey = { type: 'SET_SURVEY'; payload: ISurvey };
type ResetSurvey = { type: 'RESET_SURVEY' };

export type SurveyAction = SetSurvey | ResetSurvey;

export const setSurveyAction = (payload: ISurvey): SetSurvey => ({ type: 'SET_SURVEY', payload });
export const resetSurveyAction = (): ResetSurvey => ({ type: 'RESET_SURVEY' });
